import { STORAGE_KEY } from "@/components/CookieConsent";

function readConsentPreference(category: "analytics" | "marketing"): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { analytics?: boolean; marketing?: boolean };
    return parsed[category] === true;
  } catch {
    return false;
  }
}

export function readAnalyticsConsent(): boolean {
  return readConsentPreference("analytics");
}

export function readMarketingConsent(): boolean {
  return readConsentPreference("marketing");
}

export function isGpcEnabled(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.globalPrivacyControl === true;
}

export function isAnalyticsAllowed(): boolean {
  return readAnalyticsConsent() && !isGpcEnabled();
}

export function isMarketingAllowed(): boolean {
  return readMarketingConsent() && !isGpcEnabled();
}
